import React, { useState, useContext } from "react";
import "./style.scss";
import Icon from "react-icons-kit";
import { toast } from "react-toastify";
import { x } from "react-icons-kit/feather";
import "react-toastify/dist/ReactToastify.css";

import Requests from "../../../utils/Requests/Index";
import DeleteModal from "../../Delete/Index";
import { UserContext } from "../../../utils/context/userContext";
import { Images } from "../../../utils/Images";

const Index = (props) => {
  const { item } = props;

  const [isDelete, setDelete] = useState({
    show: false,
    loading: false,
    image: null,
    _id: null,
  });

  const { handleRefetch } = useContext(UserContext);

  const header = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  };

  // ✅ Image URL
  const imageUrl = `${process.env.REACT_APP_IMAGE_URL}/biyesadi/${item?.name}`;

  // ✅ Open delete modal
  const handleDelete = () => {
    setDelete({
      show: true,
      loading: false,
      image: imageUrl,
      _id: item?._id,
    });
  };

  // ✅ Delete API
  const submitDelete = async () => {
    setDelete((prev) => ({ ...prev, loading: true }));

    const obj = {
      imageId: isDelete._id,
    };

    const response = await Requests.MyPhoto.DeleteImage(obj, header);

    if (response.status) {
      setDelete({
        show: false,
        loading: false,
        image: null,
        _id: null,
      });

      handleRefetch(); // ✅ reload without page refresh
      toast.success("Image successfully deleted.");
    } else {
      setDelete({
        show: false,
        loading: false,
        image: null,
        _id: null,
      });

      toast.error("Image is not deleted.");
    }
  };

  return (
    <div className="gallery">
      <div className="img-container">

        {/* Image */}
        <img
          src={imageUrl || Images.NoImage}
          alt="gallery"
        />

        {/* Delete Button */}
        <div className="overlay show">
          <button
            type="button"
            className="btn delete-btn"
            onClick={handleDelete}
          >
            <Icon icon={x} size={18} />
          </button>
        </div>

      </div>

      {/* Delete Modal */}
      {isDelete.show && (
        <DeleteModal
          show={isDelete.show}
          image={isDelete.image}
          loading={isDelete.loading}
          doDelete={submitDelete}
          onHide={() =>
            setDelete((prev) => ({ ...prev, show: false }))
          }
        />
      )}
    </div>
  );
};

export default Index;